import React from 'react'
import Header from '../../../Components/Header'
import Footer from '../../../Components/Footer'

const AboutUs = () => {
  return (
    <>
      <Header/>
         <p>About Us Page</p>
      <Footer/>
    </>
  )
}

export default AboutUs
